import { ONMAP_IMAGE_MODIFIER } from '../constants';

const modifiers = Object.values(
    ONMAP_IMAGE_MODIFIER,
  ).join('|');

const regex = new RegExp(
  `(\\.(${modifiers}))?(\\.[^.]+)$`,
);

export const removeImageModifier = (
  url,
) => url.replace(regex, '$3');

export const setImageModifier = (
  url,
  modifier = ONMAP_IMAGE_MODIFIER.THUMBNAIL,
) => url.replace(regex, `${modifier ? `.${modifier}` : ''}$3`);
